<template>
  <b-modal id="contactModal" title="Contact" centered size="lg" :hide-footer="true" :header-class="'pt-4'" :header-border-variant="'light'">
    <template #modal-header>
      <div class="px-4">
        <p><strong>{{ $t('contact.sources_cta_question') }}</strong></p>
        <p><strong>{{ $t('contact.sources_cta_answer') }}</strong></p>
      </div>
      <div>
        <button class="btn btn-gray btn-close" @click="hideModal"><x-icon></x-icon></button>
      </div>
    </template>
    <div class="px-4">
      <input v-model="messageTitle" class="form-control my-4 w-100" name="messageTitle" type="text" :placeholder="$t('contact.title')">
      <textarea v-model="messageContent" class="form-control my-4" name="messageContent" :placeholder="$t('contact.description')" />
    </div>
    <div class="d-flex justify-content-center py-2">
      <button class="btn btn-small btn-orange-dark" @click="sendMessage">{{$t('global.send')}}</button>
    </div>
  </b-modal>
</template>

<script>
import { XIcon } from 'vue-feather-icons'
import axios from 'axios'

export default {
  name: 'ContactModal',

  data () {
    return {
      messageContent: '',
      messageTitle: ''
    }
  },

  methods: {
    hideModal () {
      this.$root.$emit('bv::hide::modal', 'contactModal')
    },

    sendMessage () {
      axios.post(process.env.VUE_APP_API_ENDPOINT + '/mail/support/', { title: this.messageTitle, text: this.messageContent })
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.hideModal()
            this.$bvToast.toast(this.$t('contact.message_send_success_description'), {
              autoHideDelay: 3000,
              solid: true,
              title: this.$t('contact.message_send_success'),
              variant: 'success'
            })
          }
        })
        .catch((error) => {
          if (error.response) {
            this.hideModal()
            this.$bvToast.toast(this.$t('contact.message_send_error_description'), {
              autoHideDelay: 3000,
              solid: true,
              title: this.$t('contact.message_send_error'),
              variant: 'danger'
            })
          }
        })
    }
  },

  components: { XIcon }
}
</script>
